/* unplugin-vue-components disabled */import { render } from "./query.vue?vue&type=template&id=463d1e80&scoped=true&ts=true"
import script from "./query.vue?vue&type=script&lang=ts"
export * from "./query.vue?vue&type=script&lang=ts"

import "./query.vue?vue&type=style&index=0&id=463d1e80&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\17532\\Desktop\\智慧校园\\school-h5\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-463d1e80"]])

export default __exports__